export default __webpack_public_path__ + "assets/bookmarklet.4ed6be8c1701ec3b15a8161c6f3bc775.png";